//#region Libraries
import useShowDialogAlert from "components/DialogAlert/utils/hooks/useDialogAlert";
import {
    useState
} from "react";
//#endregion
//#region Components
import SearchInDialogAlert from "components/SearchInDialogAlert/SearchInDialogAlert";
//#endregion

const CampusSearchField = ({
    allCampus,
    campus, changeCampus,
    error
}) => {
    //#region States
    const [matchedCampusList, setMatchedCampusList] = useState([]);
    const [mostSimilarCampus, setMostSimilarCampus] = useState("");
    //#endregion
    const dialogShowSearchCampus = useShowDialogAlert();
    const fillMatchedCampusList = campusName => {
        const data = allCampus.map(({ id, name }) => ({
            id, text: name
        }));
        const newMatchedData = !campusName
            ? [] 
            : data.filter(
                ({ text }) => 
                    text.toUpperCase()
                        .includes(campusName.toUpperCase())
        );
        setMatchedCampusList(newMatchedData);
        if (campusName && newMatchedData.length === 0) {
            setMostSimilarCampus(data.find(
                ({ text }) => (
                    text[0].toUpperCase() === campusName[0].toUpperCase()
                )
            )?.text || "");
        }
    }
    const clearMatchedCampusList = () => setMatchedCampusList([]);
    return (
        <SearchInDialogAlert
            campusWidth="340px"
            buttonProps={{
                text: "Busca el campus", 
                variant: "secondary",
                error,
                errorText: "No has seleccionado un campus.",
                width: "300px",
                required: true
            }}
            placeholder="Buscar Campus UTP"
            label="Buscar el campus aquí"
            changeSearchField={changeCampus}
            data={matchedCampusList}
            fillData={fillMatchedCampusList}
            clearData={clearMatchedCampusList}
            mostSimilar={mostSimilarCampus}
            firstSelection={campus.id > 0}
            name={campus.name}
            titleDialog="Buscar el campus"
            showDialogAlert={dialogShowSearchCampus.value}
            toggleDialogAlert={dialogShowSearchCampus.toggle}
            notFoundMessage="El campus que estás buscando no se encuentra en la lista"/>
    );
}

export default CampusSearchField;